import { Tooltip } from '@/components/ui/tooltip';
import { cls } from '@/utils/cls';

import {
  isKnownWarrantyCoverageStatus,
  KnownWarrantyCoverageStatus,
  type WarrantyCoverageStatus,
} from '../entities/warranty-coverage-status';

import {
  tooltipFromStatus,
  WarrantyCoverageStatusIcon,
} from './warranty-coverage-status-icon';

type WarrantyCoverageStatusBadgeProps = {
  status: WarrantyCoverageStatus;
};

const labelFromStatus: Record<KnownWarrantyCoverageStatus, string> = {
  [KnownWarrantyCoverageStatus.NO_DATA]: 'No Data',
  [KnownWarrantyCoverageStatus.VALID]: 'Valid',
  [KnownWarrantyCoverageStatus.EXPIRED]: 'Expired',
  [KnownWarrantyCoverageStatus.CASE_OPEN]: 'Potential Case',
};

const classNameFromStatus: Record<KnownWarrantyCoverageStatus, string> = {
  [KnownWarrantyCoverageStatus.NO_DATA]: 'bg-gray-50 text-gray-700',
  [KnownWarrantyCoverageStatus.VALID]: 'bg-green-50 text-green-700',
  [KnownWarrantyCoverageStatus.EXPIRED]: 'bg-red-50 text-red-700',
  [KnownWarrantyCoverageStatus.CASE_OPEN]: 'bg-blue-50 text-blue-700',
};

export function WarrantyCoverageStatusBadge({
  status,
}: WarrantyCoverageStatusBadgeProps) {
  const baseClassName =
    'inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-1 text-xs font-medium';

  if (isKnownWarrantyCoverageStatus(status)) {
    return (
      <Tooltip delay content={tooltipFromStatus[status]}>
        <span className={cls(baseClassName, classNameFromStatus[status])}>
          <WarrantyCoverageStatusIcon status={status} />
          {labelFromStatus[status]}
        </span>
      </Tooltip>
    );
  }

  return (
    <span className={cls(baseClassName, 'bg-gray-50 text-gray-700')}>
      {status}
    </span>
  );
}
